import type { HealthState } from "contracts/enums/core";

export function healthVar(state: HealthState): string {
  return `var(--${state})`;
}

export function healthLabel(state: HealthState): string {
  const labels: Record<HealthState, string> = {
    good: "Good",
    watch: "Watch",
    poor: "Poor",
    nodata: "No data",
  };
  return labels[state];
}
